export default __webpack_public_path__ + "static/media/aramex.06873882.svg";